import { mapProgressDataModel, mapSettingsDataModel, questsDataModel } from './models'

export const selectQuests = (state) => questsDataModel(state.clanSupplyQuests)
export const selectMapSettings = (state) => mapSettingsDataModel(state.clanSupplyProgressionSettings)
export const selectMapProgress = (state) => mapProgressDataModel(state.clanSupplyProgression)



// WEBPACK FOOTER //
// ./containers/ClanLanding/selectors.js